import { ID } from '@griply/types';

const filterIds = (value: unknown[]): ID[] =>
  value.filter((entry): entry is ID => typeof entry === 'string');

export const coerceIdArray = (value: unknown): ID[] =>
  Array.isArray(value) ? filterIds(value) : [];

// Undefined keeps "key absent" distinguishable from "empty list", so callers can omit the key on write-back.
export const coerceOptionalIdArray = (value: unknown): ID[] | undefined =>
  Array.isArray(value) ? filterIds(value) : undefined;
